const ChildEducationFormTranslations = {
    en: {
      labels: {
        title: 'Child Education Planning',
        description: 'Please provide details for your child\'s education planning.',
        form_timestamp: 'Timestamp',
        email: 'Email',
        form_language: 'Form Language',
        name: ' Full Name',
        mobile: ' Mobile Number',
        city_of_residence: 'City of Residence',
        city_of_residence_select: 'Select City',
        otherCity: 'Please specify your city',
        gender: ' Gender',
        dob: ' Date of Birth', // Customer's DOB
        marital_status: ' Marital Status',
        number_of_children: 'Number of Children (1-5)',
        child_name: 'Child\'s Name',
        child_detail:'Children\'s Details',
        age: 'Age', // Child's Age
        ugCostAbroadUsd: 'UG Cost Abroad (USD)',
        ugCostIndiaInr: 'UG Cost India (INR)',
        mastersCostAbroadUsd: 'Master\'s Cost Abroad (USD)',
        mastersCostIndiaInr: 'Master\'s Cost India (INR)',
        submit: 'Submit',
        selectOption: 'Select an option',
  
        // New/Modified labels for the component
        your_details: ' Details',
        next: 'Next',
        reset_all: 'Reset All',
        children_details: 'Children\'s Details',
        generate_child_forms: 'Generate Child Forms',
        go_back_personal_details: 'Go Back to Personal Details',
        child_number: 'Child', // e.g., "Child 1"
        calculate_education_plan: 'Calculate Education Plan',
        results: 'Results',
        ug: 'UG',
        masters: 'Masters',
        total_education_expenses: 'Total Education Expenses',
        assumptions: 'Assumptions',
        education_inflation_india: 'Education Inflation in India',
        education_inflation_abroad: 'Education Inflation Abroad',
        age_for_ug: 'Age for UG',
        age_for_masters: 'Age for Masters',
        years: 'Years', // For "18 Years"
        exchange_rate_fetching: 'USD to INR Conversion Rate is being fetched...',
        usd_to_inr_rate_is: 'USD to INR Conversion Rate is',
        fetched_live: 'and is fetched live',
        default_value: 'default value',
        crores: 'Crores',
        lakhs: 'Lakhs',
        expected_return:'Expected Return',
        calculation_success: 'Calculation completed and data submitted successfully!',
      },
      placeholders: {
        email: 'Enter your email address',
        name: 'Enter your full name',
        mobile: 'Enter your 10-digit mobile number',
        city_of_residence: '-- Select City --',
        otherCity: 'Enter your city',
        gender: 'Select Gender',
        dob: 'DD/MM/YYYY', // Customer DOB
        number_of_children: 'Select Number of Children',
        child_name: 'Enter child\'s name',
        age: 'Enter age between 1 to 15', // Child age
        ugCostAbroadUsd: 'Enter UG cost abroad (USD)',
        ugCostIndiaInr: 'Enter UG cost in India (INR)',
        mastersCostAbroadUsd: 'Enter Master\'s cost abroad (USD)',
        mastersCostIndiaInr: 'Enter Master\'s cost in India (INR)',
        submit: 'Submit'
      },
      errors: {
        invalidEmail: 'Please enter a valid email address.',
        invalidMobile: 'Please enter a valid 10-digit mobile number starting with 6-9 without 4 identical digits consecutively.',
        emailRequired: 'Email is required.',
        nameRequired: 'Name is required.',
        mobileRequired: 'Mobile number is required.',
        cityRequired: 'City is required.',
        requiredOtherCity: 'Please specify your city.',
        genderRequired: 'Gender is required.',
        dobRequired: 'Date of birth is required.',
        dateInvalid: 'Invalid date format.',
        maritalStatusRequired: 'Marital Status is required.',
        numberOfChildrenRequired: 'Number of children is required.',
        childNameRequired: 'Child\'s name is required.',
        invalidChildAge: 'Age must be between 1 and 15.', // Specific for child age
        ugCostRequired: 'Please provide either UG cost abroad or in India.',
        invalidUGCostAbroad: 'UG Cost Abroad must be a number.',
        invalidUGCostIndia: 'UG Cost India must be a number.',
        mastersCostRequired: 'Please provide either Masters cost abroad or in India.',
        invalidMastersCostAbroad: 'Masters Cost Abroad must be a number.',
        invalidMastersCostIndia: 'Masters Cost India must be a number.',
        submitError: 'Form submission failed.',
        failedToFetchExchangeRate: 'Unable to fetch live USD to INR rate. Using default rate: 80.',
        validationFailed: 'Please correct the errors in the form.'
      },
      data: {
        genderOptions: [
          { value: 'Male', label: 'Male' },
          { value: 'Female', label: 'Female' }

        ],
        maritalStatusOptions: [
          { value: 'unmarried', label: 'Unmarried' },
          { value: 'Married', label: 'Married' },
          { value: 'Divorced', label: 'Divorced' },
          { value: 'Widowed', label: 'Widowed' }
        ],
        cityOptions : [
          { value: 'Ahmedabad', label: 'Ahmedabad' },
          { value: 'Bengaluru', label: 'Bengaluru' },
          { value: 'Bhopal', label: 'Bhopal' },
          { value: 'Bhubaneswar', label: 'Bhubaneswar' },
          { value: 'Chandigarh', label: 'Chandigarh' },
          { value: 'Chennai', label: 'Chennai' },
          { value: 'Coimbatore', label: 'Coimbatore' },
          { value: 'Dehradun', label: 'Dehradun' },
          { value: 'Delhi', label: 'Delhi' },
          { value: 'Faridabad', label: 'Faridabad' },
          { value: 'Ghaziabad', label: 'Ghaziabad' },
          { value: 'Goa', label: 'Goa' },
          { value: 'Guwahati', label: 'Guwahati' },
          { value: 'Hyderabad', label: 'Hyderabad' },
          { value: 'Indore', label: 'Indore' },
          { value: 'Jaipur', label: 'Jaipur' },
          { value: 'Jamshedpur', label: 'Jamshedpur' },
          { value: 'Kanpur', label: 'Kanpur' },
          { value: 'Kochi', label: 'Kochi' },
          { value: 'Kolkata', label: 'Kolkata' },
          { value: 'Lucknow', label: 'Lucknow' },
          { value: 'Ludhiana', label: 'Ludhiana' },
          { value: 'Madurai', label: 'Madurai' },
          { value: 'Mangalore', label: 'Mangalore' },
          { value: 'Mumbai', label: 'Mumbai' },
          { value: 'Nagpur', label: 'Nagpur' },
          { value: 'Nashik', label: 'Nashik' },
          { value: 'Patna', label: 'Patna' },
          { value: 'Pune', label: 'Pune' },
          { value: 'Surat', label: 'Surat' },
          { value: 'Visakhapatnam', label: 'Visakhapatnam' },
          { value: 'Others', label: 'Others' }
        ],
        numberOfChildrenOptions: ['1', '2', '3', '4', '5']
      }
    }
  };
  
  export default ChildEducationFormTranslations;